import { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../nodeFactory/cssCompNode'
import { CssCompNodesRefs } from '../types'

export const componentCss = createCssCompNode('componentCss', {
	getDependencies: (component: Component, refs: CssCompNodesRefs) => ({
		breakpointsOrder: component.breakpointVariantsQuery
			? refs.breakpointVariantsQuery(component.breakpointVariantsQuery)
			: undefined,
		responsiveLayout: {
			pinnedLayer: refs.pinnedLayer(component),
			responsiveLayout: refs.responsiveLayout(component),
			layoutVariants: refs.layoutVariants(component),
		},
		variables: {
			variables: refs.variables(component),
			variablesVariants: refs.variablesVariants(component),
		},
	}),
	toViewItem: (__, deps) => deps,
})
